import { API } from "@/lib/api";

export const CONCEPTS = [
  "Colegiatura", "Anualidad", "Inscripción", "Transporte", "Uniformes", "Clases extra",
  "Comedor", "Horas extra", "Paquetes fotográficos", "Artículos",
];

export const money = (n) =>
  `$${Number(n || 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const receiptUrl = (token) => `${API}/recibo/${token}`;

export function whatsappLink(payment, tutorWhatsapp, schoolName) {
  const phone = (tutorWhatsapp || "").replace(/[^0-9]/g, "");
  if (!phone) return null;
  const lines = [
    `Hola, le compartimos el comprobante de pago de ${schoolName || "su colegio"}.`,
    "",
    `Alumno: ${payment.student_name}`,
    `Concepto: ${payment.concept}${payment.period ? ` (${payment.period})` : ""}`,
    `Folio: ${payment.folio}`,
    `Total pagado: ${money(payment.net_amount)}`,
    "",
    `Descargar comprobante: ${receiptUrl(payment.receipt_token)}`,
  ];
  return `https://wa.me/${phone}?text=${encodeURIComponent(lines.join("\n"))}`;
}
